export default function toggleMenu() {
  const trigger = document.querySelectorAll('.js-menu');
  const toggleClass = () => {
    document.body.classList.toggle('-menuOpen');
  };

  trigger.forEach((target) => {
    target.addEventListener('click', toggleClass);
  });
}
